<template>
    <div v-if="report">
        <div class="d-flex align-center justify-space-between mb-4 flex-wrap" style="row-gap: 8px;">
            <div>
                <div class="caption muted--text">Average score</div>
                <div class="font-weight-bold" style="font-size: 1.4rem">{{ Number(report.average_score).toFixed(2) }} / 5</div>
            </div>
            <div class="text-end">
                <div v-if="report.level" class="caption muted--text">Level</div>
                <div v-if="report.level" class="font-weight-medium mb-2" style="text-transform: capitalize;">{{ report.level }}</div>
                <v-chip :color="statusColor" dark label>{{ statusLabel }}</v-chip>
            </div>
        </div>

        <h3 class="strong-text--text font-weight-semibold mb-1">Progress Summary</h3>
        <p class="text--text" style="white-space: pre-line;">{{ report.progress_summary || '—' }}</p>

        <v-divider class="my-4" />

        <h3 class="strong-text--text font-weight-semibold mb-1">Topics Covered</h3>
        <ul v-if="(report.topics_covered || []).length" class="text--text">
            <li v-for="(topic, i) in report.topics_covered" :key="i">{{ topic }}</li>
        </ul>
        <p v-else class="muted--text">No topics provided.</p>

        <v-divider class="my-4" />

        <h3 class="strong-text--text font-weight-semibold mb-2">Performance Areas</h3>
        <div v-for="(rating, area) in report.performance_areas" :key="area" class="d-flex align-center justify-space-between mb-1">
            <span class="text--text">{{ area }}</span>
            <span class="font-weight-bold">{{ rating }} / 5</span>
        </div>

        <v-divider class="my-4" />

        <h3 class="strong-text--text font-weight-semibold mb-1">Areas for Improvement</h3>
        <p class="text--text" style="white-space: pre-line;">{{ report.areas_for_improvement || '—' }}</p>

        <v-divider class="my-4" />

        <h3 class="strong-text--text font-weight-semibold mb-1">Next Phase Plan</h3>
        <p class="text--text" style="white-space: pre-line;">{{ report.next_phase_plan || '—' }}</p>

        <v-divider class="my-4" />

        <h3 class="strong-text--text font-weight-semibold mb-1">Teacher's Message</h3>
        <p class="text--text" style="white-space: pre-line; font-style: italic;">{{ report.teachers_message || '—' }}</p>

        <v-divider class="my-4" />

        <div class="caption muted--text">
            <div v-if="report.submitted_at">Submitted: {{ report.submitted_at }}</div>
            <div v-if="report.marked_ready_at">Marked Ready: {{ report.marked_ready_at }}</div>
            <div v-if="report.released_at">Released: {{ report.released_at }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'QuarterlyReportView',
    props: { report: { type: Object, default: null } },
    computed: {
        statusLabel() {
            return ({ on_track: 'On Track', needs_support: 'Needs Support', at_risk: 'At Risk' })[this.report && this.report.student_status] || (this.report && this.report.student_status) || '';
        },
        statusColor() {
            return ({ on_track: 'success', needs_support: 'warning', at_risk: 'error' })[this.report && this.report.student_status] || 'grey';
        },
    },
};
</script>
